"use client";

import { useModal } from "./modalContext";
import { useEffect } from "react";
import CallPopup from "../../Modals/mainPop/callPopup";
import CustomAddLabelPopup from "../../Modals/mainPop/customAddLabelPopup";
import GenerateLoadingPopup from "../../Modals/mainPop/generateLoadingPop";
import GenerateNamePop from "../../Modals/mainPop/generateNamePop";

const ModalRoot = () => {
  const { modal, closeModal } = useModal();

  // 🔴 BODY SCROLL LOCK
  useEffect(() => {
    if (modal.isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    // cleanup (important for route change / unmount)
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [modal.isOpen]);

  if (!modal.isOpen) return null;

  switch (modal.type) {
    case "call-pop":
      return <CallPopup {...modal.props} onClose={closeModal} />;

    case "custom-add-label-pop":
      return <CustomAddLabelPopup {...modal.props} onClose={closeModal} />;

    case "generate-loading-pop":
      return <GenerateLoadingPopup {...modal.props} onClose={closeModal} />;

    case "generate-Name-pop":
      return <GenerateNamePop {...modal.props} onClose={closeModal} />;

    default:
      return null;
  }
};

export default ModalRoot;
